export default {
    getReports: state => state.reports,
    getReport: state => state.report,
    getReportById: (state) => _id => {
        return state.reports.find(({id}) => id === _id)
    },
    getLoading: state => state.loading,
    getNewIncident: state => state.newincident
}